import {
  getDonationTypeColor,
  getDonationTypeString,
} from '@/entities/donations'
import {
  type DeleteApiDonationsByUserIdDonationsDonationidPathParams,
  type UserDonationListModel,
} from '@/shared/api'
import { showDeleteConfirmationModal } from '@/shared/lib/antd-utils'
import { formatDateTimeStringToDateString } from '@/shared/lib/form-utils'
import { kopeykaToRuble } from '@/shared/lib/math'
import { Button, type TableProps, Tag } from 'antd'

import { COLUMN_WIDTH } from '../../lib/column-width'

interface UseDonationsByUserIdTableColumnsProps {
  userId: string
  handleDelete: (
    id: DeleteApiDonationsByUserIdDonationsDonationidPathParams['Id'],
    donationId: DeleteApiDonationsByUserIdDonationsDonationidPathParams['DonationId'],
  ) => void
}

export const useDonationsByUserIdTableColumns = ({
  userId,
  handleDelete,
}: UseDonationsByUserIdTableColumnsProps): TableProps<UserDonationListModel>['columns'] => {
  const handleDeleteButton = ({
    id,
    donationId,
  }: {
    id: DeleteApiDonationsByUserIdDonationsDonationidPathParams['Id']
    donationId: DeleteApiDonationsByUserIdDonationsDonationidPathParams['DonationId']
  }) => {
    showDeleteConfirmationModal({
      onConfirm: () => {
        handleDelete(id, donationId)
      },
      options: {
        content: 'Вы уверены, что хотите вернуть пожертвование?',
        okText: 'Вернуть',
        title: 'Вернуть пожертвование',
      },
    })
  }

  return [
    {
      title: 'Сумма (руб.)',
      dataIndex: 'amount',
      key: 'amount',
      ellipsis: true,
      sorter: true,
      render: (_, data) => kopeykaToRuble(data.amount),
    },
    {
      title: 'Дата',
      width: COLUMN_WIDTH.DATE,
      dataIndex: 'date',
      key: 'date',
      sorter: false,
      render: (_, data) => formatDateTimeStringToDateString(data.date),
    },
    {
      title: 'Тип платежа',
      width: COLUMN_WIDTH.TYPE,
      dataIndex: 'type',
      key: 'type',
      sorter: false,
      render: (_, data) => (
        <Tag color={getDonationTypeColor(data.type)}>
          {getDonationTypeString(data.type)}
        </Tag>
      ),
    },
    {
      title: '',
      dataIndex: 'actions',
      key: 'actions',
      width: COLUMN_WIDTH.ACTIONS,
      align: 'center',
      render: (_, data) => (
        <Button
          variant="link"
          color="danger"
          onClick={() => {
            handleDeleteButton({
              id: userId,
              donationId: data.id,
            })
          }}
        >
          Вернуть
        </Button>
      ),
    },
  ]
}
